import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const ForwardToAutoInboxMembers = () => {
  return (
    <div className={classNames(styles.content)}>
      <div className={classNames(styles.wrapIcon)}>
        <Icon icon={'arrowRight'} fontSize={16} />
      </div>
      <Typography
        tag={'div'}
        variant={'body-sm-regular'}
        color={'var(--content-primary-primary)'}
        ariaLabel={'forward_to_10_members'}
      >
        Forwarded to 10 members
      </Typography>
    </div>
  )
}
